import React from "react";
import { List, Loader2, Plus, Save } from "lucide-react";
import { PageContainer, PageHeader, Card } from "@/components/layout/PageShell";
import { Button } from "@/components/ui/button";

/**
 * Form-first master CRUD shell (mobile-erp style).
 * Default view is the add/edit form; "View list" switches to the data table.
 */
export default function MasterCrudShell({
  title,
  subtitle,
  view = "form",
  onViewChange,
  isNew = true,
  onSave,
  saving = false,
  saveDisabled = false,
  saveLabel,
  onAddNew,
  testIdPrefix = "master",
  formTitle,
  formSubtitle,
  formExtra,
  children,
  list,
}) {
  const showForm = view === "form";

  return (
    <PageContainer>
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={
          showForm ? (
            <>
              <Button
                variant="outline"
                size="sm"
                className="h-9"
                data-testid={`${testIdPrefix}-view-list`}
                onClick={() => onViewChange?.("list")}
              >
                <List size={14} className="mr-1.5" />
                View list
              </Button>
              <Button
                size="sm"
                className="h-9 bg-[#16A34A] hover:bg-emerald-700"
                data-testid={`${testIdPrefix}-save`}
                onClick={onSave}
                disabled={saving || saveDisabled}
              >
                {saving ? (
                  <Loader2 size={14} className="mr-1.5 animate-spin" />
                ) : (
                  <Save size={14} className="mr-1.5" />
                )}
                {saveLabel || (isNew ? "Save" : "Update")}
              </Button>
            </>
          ) : (
            <Button
              size="sm"
              className="h-9 bg-[#16A34A] hover:bg-emerald-700"
              data-testid={`${testIdPrefix}-add`}
              onClick={() => {
                onAddNew?.();
                onViewChange?.("form");
              }}
            >
              <Plus size={14} className="mr-1.5" />
              Add new
            </Button>
          )
        }
      />

      {showForm ? (
        <Card className="p-0">
          {(formTitle || formSubtitle || formExtra) && (
            <div className="px-5 py-3 border-b flex items-center justify-between gap-3">
              <div className="min-w-0">
                {formSubtitle ? (
                  <div className="text-[11.5px] text-slate-400 uppercase tracking-wider font-semibold">
                    {formSubtitle}
                  </div>
                ) : null}
                {formTitle ? (
                  <h2 className="text-[16px] font-semibold text-slate-900 truncate">{formTitle}</h2>
                ) : null}
              </div>
              {formExtra}
            </div>
          )}
          <div className="p-5">{children}</div>
        </Card>
      ) : (
        list
      )}
    </PageContainer>
  );
}
